import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { STAGES, STAGE_LABELS } from "../../components/shared";

const COLUMNS = ["draft", ...STAGES];

export default function Pipeline() {
  const [projects, setProjects] = useState([]);

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)); }, []);

  return (
    <div data-testid="admin-pipeline">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight text-neutral-900 font-heading">Production Pipeline</h1>
        <p className="text-neutral-500 mt-1">{projects.length} projects · click a card to manage</p>
      </div>
      <div className="flex overflow-x-auto pb-4 gap-4 items-start">
        {COLUMNS.map((stage) => {
          const items = projects.filter((p) => p.status === stage);
          return (
            <div key={stage} data-testid={`pipeline-column-${stage}`} className="flex-shrink-0 w-72 bg-neutral-100 rounded-lg p-3">
              <div className="flex items-center justify-between px-1 mb-3">
                <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-neutral-500">{STAGE_LABELS[stage]}</h3>
                <span className="text-xs font-semibold bg-white border border-neutral-200 rounded-full px-2 py-0.5 text-neutral-600">{items.length}</span>
              </div>
              <div className="space-y-2">
                {items.map((p) => (
                  <Link key={p.id} to={`/projects/${p.id}`} data-testid={`pipeline-card-${p.id}`}
                    className="block bg-white border border-neutral-200 rounded-md p-3 shadow-sm hover:shadow-md transition-shadow">
                    <p className="font-semibold text-sm text-neutral-900 leading-snug">{p.title}</p>
                    {p.plan_id === "premium" && <span className="inline-block mt-1 text-[10px] font-bold uppercase tracking-wider text-purple-700 bg-purple-50 border border-purple-200 px-1.5 py-0.5 rounded">Priority</span>}
                    <p className="text-xs text-neutral-500 mt-1">{p.author_name}</p>
                    <div className="flex justify-between items-center mt-2 text-xs text-neutral-400">
                      <span>{p.plan_name || "Unpaid"}</span>
                      <span>{new Date(p.updated_at).toLocaleDateString()}</span>
                    </div>
                    {p.asin && <p className="text-xs text-blue-700 mt-1 font-mono">{p.asin}</p>}
                  </Link>
                ))}
                {items.length === 0 && <p className="text-xs text-neutral-400 px-1 py-4 text-center">Empty</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
